import { AlertBox, Box, Button, FlexBox, Icon, Typography } from '@vp/swan';

export interface ChatErrorBannerProps {
    retryCount: number;
    onRetry: () => void;
    onReview?: () => void;
}

export function ChatErrorBanner({ retryCount, onRetry, onReview }: ChatErrorBannerProps) {
    const isPersistentError = retryCount >= 2;

    const errorMessage = isPersistentError
        ? "We're still having trouble sending your message."
        : "We couldn't send your message. Please try again.";

    return (
        <Box style={{ maxWidth: '768px', margin: '0 auto', padding: 'var(--swan-sem-space-6)' }}>
            <AlertBox skin="error" toast={false}>
                <FlexBox alignItems="flex-start" justifyContent="space-between">
                    <Typography>{errorMessage}</Typography>
                    {!isPersistentError && (
                        <Button skin="link" onClick={onRetry}>
                            <FlexBox alignItems="flex-start" gap="3">
                                <Box style={{ flexShrink: 0 }}>
                                    <Icon iconType="reset" size="small" />
                                </Box>
                                <Box>Try again</Box>
                            </FlexBox>
                        </Button>
                    )}
                    {isPersistentError && onReview && (
                        <Button skin="link" onClick={onReview}>
                            <FlexBox alignItems="flex-start" gap="3">
                                <Box style={{ flexShrink: 0 }}>
                                    <Icon iconType="customQuote" size="small" />
                                </Box>
                                <Box>Review brief</Box>
                            </FlexBox>
                        </Button>
                    )}
                </FlexBox>
            </AlertBox>
        </Box>
    );
}
